import { GradeDocument } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    documents: [],
  },
  actions: {
    async createDocument(_, params) {
      const res = await GradeDocument.create({ ...params })
      return res
    },
    async fetchDocument({ commit }, params) {
      const res = await GradeDocument.fetch({ ...params })
      commit('setDocument', res)
    },
    async removeDocument(_, id) {
      await GradeDocument.remove(id)
    }
  },
  mutations: {
    setDocument(state, docs) {
      state.documents = docs
    },
  },
}
